import React, {Component} from 'react';
import { Route } from "react-router-dom";
import '../App.css';
import '../css/all.css';

import HomePage from '../pages/HomePage'
import ResultsPage from '../pages/ResultsPage'
import PolicyPage from '../pages/PolicyPage'
import OrderPage from '../pages/OrderPage'
import ErrorPage from '../pages/ErrorPage'
import OrdersListPage from '../pages/OrdersListPage'
import HotelsListPage from '../pages/HotelsListPage'
import HotelsDetailsPage from '../pages/HotelDetailsPage'


import compose from '../utils/compose'
import {getToken,getSToken} from '../utils/token'
import withNofeshService  from './withNofeshService.hoc';
import {AppDataParam} from '../utils/constUtils'
import IdleTimer from '../utils/IdleTimer'


class AppContainerAuth extends Component {


  state = {
    isTimeout: false,
    idleTimeout:15,
    idleTimer:{},
    loading:true,
    loadingLastChance:false,
    modalDisplay:false,
    modalOrderDisplay:false,
    personData:{},
    currentSearchObj:{},
    initSearchObj : {
      searchFieldGuests_placeholder:'',
      searchFieldDates_placeholder:'',
      search_param_num_family_adulds : 0,
      search_param_num_family_children : 0,
      search_param_num_family_babies :0,            
      search_param_places : {
        checkedEilat :false,
        checkedDeadSea: false,
        checkedKineret : false, 
        checkedMerchaz : false, 
        checkedJerusalem : false,
        checkedDarom:false
      },   
      search_param_dates_months : [],      
      personsChildren : [],
      search_param_dates_range : {},
      search_by_dates: 1,
      search_param_weekdays : 3,
      vacationSelectedCycleYear: null,
      vacationSelectedCycleMonths: null,
      lastChanceType: 0
    },
    hotelsList: [],
    hotelsForOrderLastChance: [],
    ordersList: [],
    showModalFirst:false,
    modalFirstMsg:''
  }


  setModalClosed = () => {
    this.setState({ modalDisplay: false});
  }
  setModalOpened = () => {
    this.setState({ modalDisplay: true});
  }
  setModalOrderClosed = () => {
    this.setState({ modalOrderDisplay: false});
  }
  setModalOrderOpened = () => {
    this.setState({ modalOrderDisplay: true});
  }

  changeSearchOrderPlaces = (obj) => {
    Object.assign(this.changeSearchOrderPlaces, obj);
  }        


  setModalAfterLoggingClose = () => {
    this.setState({ showModalFirst: false});
  }



  onIdleTimeout = () => {
    console.log('onIdleTimeout');

    const { idleTimer } = this.state;  
    idleTimer.cleanUp();
    sessionStorage.clear();
    this.props.onLoggedOutRefresh();

  }

  onIdleExpired = () => {
    console.log('onIdleExpired');
  }


  componentDidMount = () => {


        // 1. receive data
        const { nofeshService } = this.props;      
        const {token} = getToken();

        nofeshService.getPersonData().then(res  => {                      
          console.log('AppContainerAuth componentDidMount res.data' ,res.data);

          const person = res.data.employeePerson;

          //initial settings! res.data
          let initSearchObjTmp =  this.state.initSearchObj;
          initSearchObjTmp.vacationSelectedCycleMonths = person.vacationSelectedCycleMonths;
          initSearchObjTmp.vacationSelectedCycleYear = person.vacationSelectedCycleYear;
          initSearchObjTmp.search_param_num_family_adulds = person.num_family_adulds;
          initSearchObjTmp.search_param_num_family_children = person.NumChildEntitled;
          initSearchObjTmp.search_param_num_family_babies = 0;
          initSearchObjTmp.searchFieldGuests_placeholder = person.searchFieldGuests_placeholder;
          initSearchObjTmp.EmployeeCardNum =token;
          initSearchObjTmp.personsChildren = person.personsChildren;
          this.setState({
            currentSearchObj: initSearchObjTmp,
            personData: res.data.employeePerson,
            hotelsForOrderLastChance: res.data.hotelsForOrderLastChance }); 
  

          this.setState({loading: false});

          if ( res.data.employeePerson.modalMsg)
            if (res.data.employeePerson.modalMsg.length > 0) {
              this.setState({showModalFirst: true});
              this.setState({modalFirstMsg: res.data.employeePerson.modalMsg});
              
            }


        }).catch(function(error){
          this.setState({loading: false});
          console.log('AppContainerAuth componentDidMount nofeshService ERROR: ',error);
        });


        const idleTimer = new IdleTimer({
          timeout: 900, //sec
          onTimeout: this.onIdleTimeout,
          onExpired: this.onIdleExpired
        });
        //idleTimer.cleanUp();
        idleTimer.startInterval();
        this.setState({ idleTimer: idleTimer});
  }


  
  setCurrentHotelsForOrderLastChance = (data) =>{
    let serviceOp = true;
    const { nofeshService } = this.props;

    this.setState({loadingLastChance: true});
    let currentLastChanceObj = {}; 

    

    const {token} = getToken();
    currentLastChanceObj.EmployeeCardNum = token;

    if (data == undefined){
        currentLastChanceObj.search_param_num_family_adulds = this.state.currentSearchObj.search_param_num_family_adulds;
        currentLastChanceObj.personsChildren = this.state.personData.personsChildren;
        currentLastChanceObj.vacationSelectedCycleYear = this.state.currentSearchObj.vacationSelectedCycleYear;
        currentLastChanceObj.search_param_weekdays = this.state.currentSearchObj.search_param_weekdays;
        currentLastChanceObj.search_param_places = this.state.currentSearchObj.search_param_places;
      
    } else {

      if (data.num_family_adulds){
        currentLastChanceObj.search_param_num_family_adulds = data.num_family_adulds;
      } else {
        currentLastChanceObj.search_param_num_family_adulds = this.state.currentSearchObj.search_param_num_family_adulds;
      }
      if (data.personsChildren){
        currentLastChanceObj.personsChildren = data.personsChildren;
      } else {
        currentLastChanceObj.personsChildren = this.state.personData.personsChildren;
      }
      if (data.vacationSelectedCycleYear){
        currentLastChanceObj.vacationSelectedCycleYear = data.vacationSelectedCycleYear;
      } else {
        currentLastChanceObj.vacationSelectedCycleYear = this.state.currentSearchObj.vacationSelectedCycleYear;
      }

      if (data.search_param_weekdays){
        currentLastChanceObj.search_param_weekdays = data.search_param_weekdays;
      }  else {
        currentLastChanceObj.search_param_weekdays = this.state.currentSearchObj.search_param_weekdays;
      }

      if (data.search_param_places){
        currentLastChanceObj.search_param_places = data.search_param_places;
      }  else {
        currentLastChanceObj.search_param_places = this.state.currentSearchObj.search_param_places;
      }
    }

    nofeshService.getSearchHotelsForOrderLastChance(currentLastChanceObj).then(res  => {                      
      console.log('AppContainerAuth setCurrentHotelsForOrderLastChance res.data' ,res.data);
      if ( res.data.status == "1") {
        this.setState({ hotelsForOrderLastChance: res.data.hotelsForOrder }); 
      } else {
        serviceOp = false;
        this.setState({ hotelsForOrderLastChance: [] });
      }
      this.setState({loadingLastChance: false});

    }).catch(function(error){
      serviceOp = false;
      console.log('AppContainerAuth getSearchHotelsForOrderLastChance nofeshService ERROR: ',error);
    }).finally(() => {

      if (!serviceOp) 
      {
        this.setState({ hotelsForOrderLastChance: [] });
      }
    });


    console.log('AppContainerAuth getSearchHotelsForOrderLastChance serviceOp', serviceOp);
    

    this.setState({loadingLastChance: false});
    this.forceUpdate();

  }




  
  setCurrentHotelsForOrderLastChanceHomePage = (data) =>{
    let serviceOp = true;
    const { nofeshService } = this.props;

    this.setState({loadingLastChance: true});
    let currentLastChanceObj = {}; 


    const {token} = getToken();

    currentLastChanceObj.EmployeeCardNum = token;

    if (data == undefined){
        currentLastChanceObj.search_param_num_family_adulds = this.state.currentSearchObj.search_param_num_family_adulds;
        currentLastChanceObj.personsChildren = this.state.personData.personsChildren;
        currentLastChanceObj.vacationSelectedCycleYear = this.state.currentSearchObj.vacationSelectedCycleYear;
        currentLastChanceObj.search_param_weekdays = this.state.currentSearchObj.search_param_weekdays;
        currentLastChanceObj.search_param_places = this.state.currentSearchObj.search_param_places;
        currentLastChanceObj.lastChanceType = this.state.currentSearchObj.lastChanceType;
      
    } else {

      if (data.num_family_adulds){
        currentLastChanceObj.search_param_num_family_adulds = data.num_family_adulds;
      } else {
        currentLastChanceObj.search_param_num_family_adulds = this.state.currentSearchObj.search_param_num_family_adulds;
      }
      if (data.personsChildren){
        currentLastChanceObj.personsChildren = data.personsChildren;
      } else {
        currentLastChanceObj.personsChildren = this.state.personData.personsChildren;
      }
      if (data.vacationSelectedCycleYear){
        currentLastChanceObj.vacationSelectedCycleYear = data.vacationSelectedCycleYear;
      } else {
        currentLastChanceObj.vacationSelectedCycleYear = this.state.currentSearchObj.vacationSelectedCycleYear;
      }

      if (data.search_param_weekdays){
        currentLastChanceObj.search_param_weekdays = data.search_param_weekdays;
      }  else {
        currentLastChanceObj.search_param_weekdays = this.state.currentSearchObj.search_param_weekdays;
      }

      if (data.search_param_places){
        currentLastChanceObj.search_param_places = data.search_param_places;
      }  else {
        currentLastChanceObj.search_param_places = this.state.currentSearchObj.search_param_places;
      }

      // new
      if (data.lastChanceType){
        currentLastChanceObj.lastChanceType = data.lastChanceType;
      }  else {
        currentLastChanceObj.lastChanceType = this.state.currentSearchObj.lastChanceType;
      }
    }

    nofeshService.getSearchHotelsForOrderLastChance(currentLastChanceObj).then(res  => {                      
      console.log('AppContainerAuth setCurrentHotelsForOrderLastChanceHomePage res.data' ,res.data);
      if ( res.data.status == "1") {
        this.setState({ hotelsForOrderLastChance: res.data.hotelsForOrder }); 
      } else {
        serviceOp = false;
        this.setState({ hotelsForOrderLastChance: [] });
      }
      this.setState({loadingLastChance: false});

    }).catch(function(error){
      serviceOp = false;
      console.log('AppContainerAuth setCurrentHotelsForOrderLastChanceHomePage nofeshService ERROR: ',error);
    }).finally(() => {

      if (!serviceOp) 
      {
        this.setState({ hotelsForOrderLastChance: [] });
      }
      this.setState({loadingLastChance: false});
    });


    console.log('AppContainerAuth setCurrentHotelsForOrderLastChanceHomePage serviceOp', serviceOp);
    

   
    this.forceUpdate();

  }





  setCurrentAppHotelsList = (data) =>{

    console.log('AppContainerAuth setCurrentAppHotelsList data ' ,data);
    this.setState({ hotelsList: data.hotelsList});
  }

  setCurrentAppData = (data, param) =>{

    console.log('AppContainerAuth setCurrentAppData data ' ,data);
    console.log('AppContainerAuth setCurrentAppData param ' ,param);


    this.setState(prevState => {
      let currentSearchObj = Object.assign({}, prevState.currentSearchObj); 

      if ( param == AppDataParam.reset_search_param_places) {
        currentSearchObj.search_param_places = {
          checkedEilat :false,
          checkedDeadSea: false,
          checkedLowerGalilee : false,
          checkedUpperGalilee: false,
          checkedWestGalilee: false,
          checkedKineret : false, 
          checkedMerchaz : false, 
          checkedJerusalem : false,
          checkedHasharon:false,
          checkedDarom:false
        };
        return { currentSearchObj };
      }

      if ( param == AppDataParam.reset_search_param_dates_months) {
        currentSearchObj.search_param_dates_months = [];
        currentSearchObj.searchFieldDates_placeholder = '';
        currentSearchObj.search_by_dates = 0;

        return { currentSearchObj };
      }
      if ( param == AppDataParam.reset_search_param_dates_range) {
        currentSearchObj.search_param_dates_range = {};
        currentSearchObj.searchFieldDates_placeholder = '';
        currentSearchObj.search_by_dates = 0;
        return { currentSearchObj };
      }

      if ( param == AppDataParam.reset_search_param_guests) {
        currentSearchObj.searchFieldGuests_placeholder = '';
        currentSearchObj.search_param_num_family_adulds = 0;
        currentSearchObj.search_param_num_family_children = 0;
        currentSearchObj.search_param_num_family_babies = 0;
        return { currentSearchObj };
      }


      if ( param == AppDataParam.reset_search_param_vacationCyclesYears) {
        currentSearchObj.vacationSelectedCycleYear = null;
        currentSearchObj.vacationSelectedCycleMonths = null;
        currentSearchObj.lastChanceType = 0;
        return { currentSearchObj };
      }
      
      //new last chance reset
      if ( param == AppDataParam.reset_last_chance) {
        currentSearchObj.lastChanceType = 0;
        return { currentSearchObj };
      }

      //cycle
      if ( param == AppDataParam.reset_to_new_search_param_vacationCyclesYears) {

        if (data.vacationSelectedCycleYear){
          currentSearchObj.vacationSelectedCycleYear = data.vacationSelectedCycleYear;
        }
        if (data.vacationSelectedCycleMonths){
          currentSearchObj.vacationSelectedCycleMonths = data.vacationSelectedCycleMonths;
        }
        currentSearchObj.search_by_dates = 0;
        currentSearchObj.searchFieldDates_placeholder = '';
        currentSearchObj.search_param_dates_months = [];
        currentSearchObj.search_param_dates_range = {};
        currentSearchObj.lastChanceType = 0;
        //this.setState({ hotelsForOrderLastChance: [] }); 

        return { currentSearchObj };
      }




      // week part
      if (data.search_param_weekdays){
        currentSearchObj.search_param_weekdays = data.search_param_weekdays;
      }

         //dates
      if (data.search_param_dates_months){
        currentSearchObj.search_param_dates_months = data.search_param_dates_months;
        currentSearchObj.searchFieldDates_placeholder = data.searchFieldDates_placeholder;
        currentSearchObj.search_by_dates = data.search_by_dates;
      }

      if (data.search_param_dates_range){
        currentSearchObj.search_param_dates_range = data.search_param_dates_range;
        currentSearchObj.searchFieldDates_placeholder = data.searchFieldDates_placeholder;
        currentSearchObj.search_by_dates = data.search_by_dates;
      }
      
      //places
      if (data.search_param_places){
        currentSearchObj.search_param_places = data.search_param_places;
      }

      //geusts
      if (data.num_family_adulds){
        currentSearchObj.num_family_adulds = data.num_family_adulds;
      }
      if (data.personsChildren){
        currentSearchObj.personsChildren = data.personsChildren;
      }
      if (data.searchFieldGuests_placeholder){
        currentSearchObj.searchFieldGuests_placeholder = data.searchFieldGuests_placeholder;
      }
      if (data.search_param_num_family_adulds){
        currentSearchObj.search_param_num_family_adulds = data.search_param_num_family_adulds;
      }
      if (data.search_param_num_family_children){
        currentSearchObj.search_param_num_family_children = data.search_param_num_family_children;
      }
      if (data.search_param_num_family_babies){
        currentSearchObj.search_param_num_family_babies = data.search_param_num_family_babies;
      }

      if (data.personsChildren){
        currentSearchObj.personsChildren = data.personsChildren;
      }

      /*
      if (data.lastChanceType){
        currentSearchObj.lastChanceType = data.lastChanceType;
      }  else {
        currentSearchObj.lastChanceType = this.state.currentSearchObj.lastChanceType;
      }
      */
     if (data.lastChanceType != undefined){
        currentSearchObj.lastChanceType = data.lastChanceType;
     } 



      
      // creating copy of state variable jasper
      console.log('AppContainerAuth setCurrentAppData o ' ,currentSearchObj);
      return { currentSearchObj };
    })

    if (data  != undefined) {
      if (data.lastChanceType != undefined) {
        if (data.lastChanceType == 0) {
          console.log('AppContainerAuth setCurrentAppData data.lastChanceType == 0 ');
          this.setState({ hotelsForOrderLastChance: [] });
        }
      }
    }
    
    //this.setState({ hotelsForOrderLastChance: [] }); 
      // new


    //this.setCurrentHotelsForOrderLastChance(data);

    //this.forceUpdate();

  }


  render() {         


    return (      
        <div className="AppNofeshContainer">       

              <Route
                  path='/'
                  render={(props) => (
                    <HomePage {...props}   
                    personData={this.state.personData} 
                    setCurrentAppData={this.setCurrentAppData}
                    currentSearchObj={this.state.currentSearchObj}
                    loading={this.state.loading}
                    loadingLastChance={this.state.loadingLastChance}
                    onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    hotelsForOrderLastChance={this.state.hotelsForOrderLastChance}
                    setCurrentHotelsForOrderLastChanceHomePage={this.setCurrentHotelsForOrderLastChanceHomePage}
                    showModalFirst={this.state.showModalFirst}
                    modalFirstMsg={this.state.modalFirstMsg}
                    setModalAfterLoggingClose={this.setModalAfterLoggingClose}
                    />
                  )}
                  exact
              /> 

              <Route
                  path='/results'
                  render={(props) => (
                    <ResultsPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      currentSearchObj={this.state.currentSearchObj}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 

              <Route
                  path='/hotels'
                  render={(props) => (
                    <HotelsListPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      setCurrentAppHotelsList={this.setCurrentAppHotelsList}
                      hotelsList={this.state.hotelsList}
                      back={0}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 

              <Route
                  path='/hotels/:id'
                  render={(props) => (
                    <HotelsListPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      setCurrentAppHotelsList={this.setCurrentAppHotelsList}
                      hotelsList={this.state.hotelsList}
                      back={1}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 

              <Route
                  path='/hotelDetails'
                  render={(props) => (
                    <HotelsDetailsPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 
              
              <Route
                  path='/order/:id'
                  render={(props) => (
                    <OrderPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      currentSearchObj={this.state.currentSearchObj}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 



              <Route
                  path='/emsg'
                  render={(props) => (
                    <ErrorPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 

              <Route
                  path='/orders'
                  render={(props) => (
                    <OrdersListPage {...props}   
                      personData={this.state.personData} 
                      setCurrentAppData={this.setCurrentAppData}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 



              <Route
                  path='/policy'
                  render={(props) => (
                    <PolicyPage {...props}   
                      personData={this.state.personData} 
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}
                    />
                  )}
                exact 
              /> 

        </div>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(AppContainerAuth);



